import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { mapActions } from "vuex";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "lifestyle-list",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        order: "views",
        keyword: "",
        status: "",
        subjectStatus: "",
        isRecommend: "",
        tag: "",
        name: "",
        phone: "",
        match_location: ""
      },
      pageDB: null,
      tagList: [],
      selectTagLoading: false,
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var data, filterKeys;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.databasePage({
              user: true
            });
          case 1:
            _this.pageDB = _context.v;
            _context.n = 2;
            return _this.pageDB.value();
          case 2:
            data = _context.v;
            // Restore saved filter state
            if (data.searchForm) {
              filterKeys = ["order", "status", "subjectStatus", "isRecommend", "tag"];
              filterKeys.forEach(function (key) {
                if (data.searchForm[key] !== undefined) {
                  _this.searchForm[key] = data.searchForm[key];
                }
              });
            }
            _this.getData();
            _this.getTagList();
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  watch: {
    "searchForm.order": function searchFormOrder() {
      if (this.searchForm.order == "recommend") {
        this.searchForm.status = "1";
        this.searchForm.subjectStatus = "2";
        this.searchForm.isRecommend = "1";
      } else {
        this.searchForm.status = "";
        this.searchForm.subjectStatus = "";
        this.searchForm.isRecommend = "";
      }
    },
    searchForm: {
      handler: function handler() {
        var _this2 = this;
        return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var filterState, filterKeys;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (_this2.pageDB) {
                  filterState = {};
                  filterKeys = ["order", "status", "subjectStatus", "isRecommend", "tag"];
                  filterKeys.forEach(function (key) {
                    filterState[key] = _this2.searchForm[key];
                  });
                  _this2.pageDB.set("searchForm", filterState).write();
                }
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }))();
      },
      deep: true
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/db", ["database", "get", "databasePage"])), {}, {
    resetSearch: function resetSearch() {
      this.searchForm = {
        pn: 1,
        ps: 20,
        order: "views",
        keyword: "",
        status: "",
        subjectStatus: "",
        isRecommend: "",
        tag: "",
        name: "",
        phone: "",
        match_location: ""
      };
      this.getData();
    },
    getTagList: function getTagList(query) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.getLifestyleTagList({
                keywords: query
              });
            case 1:
              res = _context3.v;
              _this3.tagList = res.data.list;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this4.searchForm.pn = 1;
              }
              _this4.tableLoading = true;
              _context4.n = 1;
              return _this4.$api.getLifestyleList(_this4.searchForm);
            case 1:
              res = _context4.v;
              _this4.tableData = res.data.list;
              _this4.total = res.data.count;
              _this4.tableLoading = false;
              _this4.getUserListByIds(_this4.tableData, "userId");
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    // 开放|关闭
    operation: function operation(row) {
      var _this5 = this;
      this.$confirm("确认操作， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.operateLifestyle({
                id: row.id,
                subjectStatus: row.subjectStatus == 2 ? 1 : 2
              });
            case 1:
              _this5.$message.success("操作成功");
              _this5.getData();

              // 操作上报
              _this5.$operationLog.push({
                code: row.subjectStatus == 2 ? 'close' : 'open',
                userId: row.userId,
                operationType: "lifestyle",
                detailBatchNo: row.id
              });
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))).catch(function () {});
    },
    // 推荐|取消推荐
    recommend: function recommend(row) {
      var _this6 = this;
      this.$confirm("是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this6.$api.recommendLifestyle({
                type: row.isRecommend == 1 ? 0 : 1,
                id: row.id
              });
            case 1:
              _this6.$message.success("操作成功");
              _this6.getData();

              // 操作上报
              _this6.$operationLog.push({
                code: row.isRecommend == 1 ? 'unrecommend' : 'recommend',
                userId: row.userId,
                operationType: "lifestyle",
                detailBatchNo: row.id
              });
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))).catch(function () {});
    },
    updateItem: function updateItem(row) {
      this.$router.push({
        path: "/lifestyle/update",
        query: {
          id: row.id,
          from: 'lifestyle_list_edit'
        }
      });
    },
    deleteItem: function deleteItem(row) {
      var _this7 = this;
      this.$confirm("删除， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this7.$api.deleteLifestyle({
                id: row.id
              });
            case 1:
              _this7.$message.success("操作成功");
              _this7.getData();

              // 操作上报
              _this7.$operationLog.push({
                code: 'delete',
                userId: row.userId,
                operationType: "lifestyle",
                detailBatchNo: row.id
              });
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))).catch(function () {});
    },
    comment: function comment(row) {
      this.$router.push({
        path: "/lifestyle/comment",
        query: {
          id: row.id
        }
      });
    }
  })
};